const colorMap = {
  rojo: 'red',
  verde: 'green',
  azul: 'blue',
  amarillo: 'yellow',
  negro: 'black',
  blanco: 'white',
  naranja: 'orange',
  morado: 'purple',
  gris: 'gray',
  celeste: 'skyblue',
  rosa: 'pink',
  marron: 'brown',
  violeta: 'violet',
  turquesa: 'turquoise',
  magenta: 'magenta',
  fucsia: 'fuchsia',
};

export const formatearFecha = (fecha: string): string => {
  if (!fecha) return "";

  const fechaObj = new Date(fecha);
  if (isNaN(fechaObj.getTime())) return "";

  return fechaObj.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};
export const formatearFechayHora = (fecha: string): string => {
  if (!fecha) return "";

  const fechaObj = new Date(fecha);
  if (isNaN(fechaObj.getTime())) return "";

  const fechaFormateada = fechaObj.toLocaleDateString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    timeZone: "UTC",
  });

  const horaFormateada = fechaObj.toLocaleTimeString("es-ES", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "UTC",
  });

  return `${fechaFormateada} ${horaFormateada}`;
};

export const formatearFechaDos = (fechaInput) => {
  const fecha = new Date(fechaInput);
  const año = fecha.getFullYear();
  const mes = String(fecha.getMonth() + 1).padStart(2, '0');
  const dia = String(fecha.getDate()).padStart(2, '0');
  return `${año}-${mes}-${dia}`;
};



export const validEmails = (input: string): boolean => {

  const normalized = input.trim().replace(/[\s;]+/g, ";");

  const emails = normalized
    .split(";")
    .map(email => email.trim())
    .filter(email => email !== "");

  const emailRegex = /^[\w.%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

  return emails.length > 0 && emails.every(email => emailRegex.test(email));
};

export const getColorTraductor = (color: string) => {
  const colorLower = color.toLowerCase();
  const colorInEnglish = colorMap[colorLower] || color;

  return colorInEnglish;
};

export const handleOrder = (value: string, order: string, type: string): string => {
  let orderValue = "";
  if (type === "infoMuestras") {
    switch (value) {
      case "Nro. Muestra":
        orderValue = "Código";
        break;
      case "Fecha Análisis":
        orderValue = "Fecha Análisis";
        break;
      case "Planta":
        orderValue = "Planta";
        break;
      case "Equipo":
        orderValue = "Equipo";
        break;
      case "Pto. de Toma":
        orderValue = "Punto Toma";
        break;
      case "Lubricante":
        orderValue = "Lubricante";
        break;
      case "Estado Final":
        orderValue = "Estado Final Desc";
        break;
      default:
        orderValue = value;
        break;
    }
  }

  if (
    order === "" ||
    order.replace("-", "") !== orderValue
  ) {
    return orderValue;
  }

  if (order.startsWith("-")) {
    return order.replace("-", "");
  } else {
    return "-" + order;
  }
};